import { Button, ButtonGroup } from '@chakra-ui/react';
import { Tooltip } from '@/components/ui/tooltip';
import type { AreaLayerMode } from './AreaLayersPanel'

interface LayerModeSwitchProps {
  mode: AreaLayerMode
  allowCompare: boolean
  onModeChange: (m: AreaLayerMode) => void
  quadrantDisabled?: boolean
  quadrantDisabledReason?: string
}

const MODES: { key: AreaLayerMode; label: string }[] = [
  { key: 'single', label: 'Single metric' },
  { key: 'quadrant', label: 'Quadrant' },
  { key: 'compare', label: 'Compare' },
]

export function LayerModeSwitch({
  mode, allowCompare, onModeChange, quadrantDisabled = false, quadrantDisabledReason,
}: LayerModeSwitchProps) {
  return (
    <ButtonGroup attached size="xs" variant="outline" w="full">
      {MODES.filter(m => m.key !== 'compare' || allowCompare).map(m => {
        const disabled = m.key === 'quadrant' && quadrantDisabled
        const button = (
          <Button
            key={m.key}
            flex={1}
            colorPalette={mode === m.key ? 'blue' : undefined}
            variant={mode === m.key ? 'solid' : 'outline'}
            disabled={disabled}
            onClick={() => onModeChange(m.key)}
          >
            {m.label}
          </Button>
        )
        return disabled && quadrantDisabledReason
          ? <Tooltip key={m.key} content={quadrantDisabledReason} showArrow>{button}</Tooltip>
          : button;
      })}
    </ButtonGroup>
  );
}
